<template>
	<div>
		<h4 class="mb-3">{{ title }}</h4>

		<b-form-file
			v-model="file"
			:state="Boolean(file)"
			:placeholder="$t('choose-file-or-drop-here-ellipses')"
			:drop-placeholder="$t('drop-file-here-ellipses')"
			accept=".csv"
			data-cy="upload-file-input"
			@input="onFileSelected"
			class="mb-3"
		></b-form-file>

		<b-progress v-if="loadingPreview" :value="100" variant="primary" animated class="mb-3"></b-progress>

		<div v-if="preview">
			<p class="text-muted small mb-2">
				{{ preview.file_name }} — {{ preview.row_count }} rows, {{ preview.column_count }} columns
			</p>
			<div class="table-responsive mb-3">
				<table class="table table-sm table-bordered">
					<thead class="thead-light">
						<tr>
							<th class="text-muted" style="width:2rem">#</th>
							<th v-for="(h, i) in preview.headers" :key="i">
								<span class="text-muted small d-block">col {{ i }}</span>
								{{ h || '(empty)' }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, ri) in preview.rows" :key="ri">
							<td class="text-muted">{{ ri + 1 }}</td>
							<td v-for="(cell, ci) in row" :key="ci">{{ cell }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="d-flex">
				<b-button v-if="showBack" variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
				<b-button variant="primary" @click="$emit('next')">
					{{ $t('next') }}: {{ $t('map-columns') }} →
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		loadingPreview: { type: Boolean, default: false },
		preview:        { type: Object,  default: null },
		title:          { type: String,  required: true },
		showBack:       { type: Boolean, default: true },
	},
	data() {
		return { file: null };
	},
	methods: {
		onFileSelected() {
			if (!this.file) return;
			this.$emit('file-selected', this.file);
		},
	},
};
</script>
